import {
  LoginLogoutMenuItemLabel,
  LoginLogoutMenuItemWrapper,
} from './components/LoginLogoutMenuItem/LoginLogoutMenuItem.tsx';
import type { PageGroup } from './page.ts';
import { HomeMenuItemLabel } from './pages/manage/home/components/HomeMenuItemLabel/HomeMenuItemLabel.tsx';
import { UserProfileMenuItemLabel } from './pages/manage/userProfile/components/UserProfileMenuItemLabel.tsx';

export const getDashboardBreadcrumbs = (
  pageKey: keyof typeof DASHBOARD_PAGES,
) => [
  {
    title: 'Dashboard',
    href: '/manage',
  },
  {
    title: DASHBOARD_PAGES[pageKey].label,
    href: DASHBOARD_PAGES[pageKey].path,
  },
];

export const DASHBOARD_PAGES = {
  home: {
    path: '/manage',
    label: 'Home',
    icon: 'Home',
    reactLabel: HomeMenuItemLabel,
    type: 'standalone',
    allowLoggedOut: true,
  },
  credentials: {
    path: '/manage/credentials',
    label: 'Client credentials',
    type: 'standalone',
  },
  polling: {
    path: '/manage/events',
    label: 'Polling',
    type: 'standalone',
  },
  graphQlExplorer: {
    path: '/manage/graphql-explorer',
    label: 'GraphQL Explorer',
    icon: 'GraphQL',
    type: 'standalone',
  },
  hirerRelationships: {
    path: '/manage/hirers',
    label: 'Hirer relationships',
    type: 'standalone',
  },
  jobAds: {
    path: '/manage/job-ads',
    label: 'Job ads',
    type: 'standalone',
  },
  notifications: {
    path: '/manage/notifications',
    label: 'Notifications',
    icon: 'Notifications',
    type: 'standalone',
  },
  jobPostingFeatures: {
    path: '/manage/job-posting',
    label: 'Features',
    type: 'standalone',
  },
  users: {
    path: '/manage/users',
    label: 'Users',
    icon: 'Users',
    type: 'standalone',
  },
  profile: {
    path: '/manage/user-profile',
    label: 'Profile',
    icon: 'UserProfile',
    type: 'standalone',
    reactLabel: UserProfileMenuItemLabel,
  },
  organizations: {
    path: '/manage/organizations',
    label: 'Organizations',
    icon: 'Organizations',
    type: 'standalone',
  },
  webhookPlayground: {
    path: '/manage/webhook-playground',
    label: 'Webhook playground',
    type: 'standalone',
  },
  integrationHealth: {
    path: '/manage/integration-health',
    label: 'Integration health',
    icon: 'Monitoring',
    type: 'standalone',
  },
  webhookSubscriptions: {
    route: '/manage/webhooks/:subscriptionId?',
    path: '/manage/webhooks',
    label: 'Webhook subscriptions',
    type: 'standalone',
  },
  securityIncident: {
    path: '/manage/security-incident',
    label: 'Report a security incident',
    icon: 'Security',
    type: 'standalone',
    allowLoggedOut: true,
  },
} as const;

export const site: PageGroup[] = [
  {
    children: [DASHBOARD_PAGES.home, DASHBOARD_PAGES.integrationHealth],
  },
  {
    label: 'Getting started',
    children: [
      {
        label: 'Auth',
        type: 'standalone',
        icon: 'Auth',
        menuItemStartExpanded: true,
        children: [
          DASHBOARD_PAGES.credentials,
          DASHBOARD_PAGES.hirerRelationships,
        ],
      },
      DASHBOARD_PAGES.graphQlExplorer,
      {
        label: 'Events',
        type: 'standalone',
        icon: 'Webhook',
        menuItemStartExpanded: true,
        children: [
          DASHBOARD_PAGES.webhookSubscriptions,
          DASHBOARD_PAGES.webhookPlayground,
          DASHBOARD_PAGES.polling,
        ],
      },
    ],
  },
  {
    label: 'Use Cases',
    children: [
      {
        label: 'Job Posting',
        type: 'standalone',
        icon: 'JobPosting',
        menuItemStartExpanded: true,
        children: [DASHBOARD_PAGES.jobPostingFeatures, DASHBOARD_PAGES.jobAds],
      },
    ],
  },
  {
    label: 'Settings',
    children: [
      DASHBOARD_PAGES.notifications,
      DASHBOARD_PAGES.users,
      DASHBOARD_PAGES.profile,
      DASHBOARD_PAGES.organizations,
      DASHBOARD_PAGES.securityIncident,
      {
        label: 'Log out',
        type: 'standalone',
        icon: 'Logout',
        reactLabel: LoginLogoutMenuItemLabel,
        menuItemWrapper: LoginLogoutMenuItemWrapper,
      },
    ],
  },
];
